import { motion } from "framer-motion";

const agents = [
  {
    id: 1,
    name: "Carlos",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
    online: true,
  },
  {
    id: 2,
    name: "Amanda",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face",
    online: true,
  },
  {
    id: 3,
    name: "Bruno",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
    online: true,
  },
  {
    id: 4,
    name: "Julia",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
    online: true,
  },
  {
    id: 5,
    name: "Rafael",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
    online: false,
  },
  {
    id: 6,
    name: "Mariana",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face",
    online: true,
  },
  {
    id: 7,
    name: "Lucas",
    avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=face",
    online: true,
  },
  {
    id: 8,
    name: "Beatriz",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face",
    online: false,
  },
];

export function AgentsOnline() {
  const onlineCount = agents.filter((a) => a.online).length;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 }}
      className="rounded-[14px] bg-white p-6 shadow-sm border border-[#E2E8F0]"
    >
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-[#0F172A]">Agentes Online</h3>
        <span className="rounded-full bg-green-50 px-3 py-1 text-xs font-semibold text-[#22C55E]">
          {onlineCount} online
        </span>
      </div>

      <div className="flex flex-wrap gap-4">
        {agents.map((agent, index) => (
          <motion.div
            key={agent.id}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6 + index * 0.05 }}
            className="flex flex-col items-center"
          >
            <div className="relative">
              <img
                src={agent.avatar}
                alt={agent.name}
                className="h-12 w-12 rounded-full object-cover ring-2 ring-white"
              />
              <span
                className={`absolute bottom-0 right-0 h-3.5 w-3.5 rounded-full ring-2 ring-white ${
                  agent.online ? "bg-[#22C55E]" : "bg-[#94A3B8]"
                }`}
              />
            </div>
            <span className="mt-2 text-xs text-[#64748B]">{agent.name}</span>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}